import type { BeckyTopology, Topology, Logger } from '@wix/thunderbolt-becky-types'

export const VIEWER_APPS_URL_KEY = 'viewerAppsUrl' as const
export const VIEWER_ASSETS_URL_KEY = 'viewerAssetsUrl' as const
export const VIEWER_APPS_FALLBACK_URL = 'https://viewer-apps.parastorage.com'
export const VIEWER_ASSETS_FALLBACK_URL = 'https://viewer-assets.parastorage.com'

/**
 * Picks the appropriate topology based on the environment (browser vs server).
 */
export const pickTopologyAccordingToEnv = (
	beckyTopology: BeckyTopology,
	isBrowser: boolean = typeof window !== 'undefined'
): Topology => (isBrowser ? beckyTopology.publicTopology : beckyTopology.environmentTopology)

/**
 * Gets a URL from topology with a fallback value if the URL is not defined.
 */
export const getTopologyUrl = (
	beckyTopology: BeckyTopology | undefined,
	urlKey: keyof Topology,
	fallbackUrl: string
): string => {
	if (!beckyTopology) {
		return fallbackUrl
	}
	const topology = pickTopologyAccordingToEnv(beckyTopology)
	return topology[urlKey] || fallbackUrl
}

/**
 * Replaces the base URL of a given URL with a new base URL.
 */

export const replaceUrlBase = (url: string, newBaseUrl: string, appDefId: string, logger?: Logger): string => {
	try {
		const urlObj = new URL(url)
		return newBaseUrl + urlObj.pathname + urlObj.search
	} catch (error) {
		logger?.warn(`Failed to replace base URL for ${url}`, { appDefId, url, newBaseUrl, error: { message: error?.message, stack: error?.stack } })
		return url
	}
}
